import { useState } from 'react'
import { Box } from '@mui/material'
import { useAuth } from '../../context/AuthContext'
import { ImpersonationBanner } from './ImpersonationBanner'

/** Fallback offset when banner height is not yet measured. */
export const VIEW_AS_BANNER_OFFSET_PX = 52

/**
 * Renders the view-as exit banner on every route (including onboarding shells
 * that skip LayoutWrapper) and offsets page content so nothing sits under it.
 */
export function ViewAsChrome({ children }) {
  const { isViewingAsUser } = useAuth()
  const [bannerHeight, setBannerHeight] = useState(VIEW_AS_BANNER_OFFSET_PX)

  return (
    <>
      <ImpersonationBanner onHeightChange={isViewingAsUser ? setBannerHeight : undefined} />
      <Box
        sx={{
          minHeight: '100vh',
          pt: isViewingAsUser ? `${bannerHeight}px` : 0,
          transition: 'padding-top 0.15s ease',
        }}
      >
        {children}
      </Box>
    </>
  )
}
